import React from 'react';

class TopPanel extends React.Component {
  render() {
    return <div />;
  }
}

export default TopPanel;
